import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d5ebf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("a", {
    class: "social-item",
    href: _ctx.item.link,
    target: "_blank"
  }, [
    _createTextVNode(_toDisplayString(_ctx.item.title) + " ", 1),
    _createVNode(_component_base_icon, {
      icon: _ctx.item.icon
    }, null, 8, ["icon"])
  ], 8, _hoisted_1))
}